import { api } from './client';

export type FieldGeometrySource = 'GPS_WALK' | 'HAND_DRAW' | 'LAND_TITLE_OCR';
export type FieldCultivationStatus = 'CULTIVATING' | 'PAUSED' | 'FALLOW';

export interface BackendField {
  _id: string;
  farmerId: string;
  geometry: { type: 'Polygon'; coordinates: number[][][] };
  source: FieldGeometrySource;
  areaHa?: number;
  landTitleVerified: boolean;
  overlapFlag: boolean;
  overlapsWithFieldIds: string[];
  code?: string;
  name?: string;
  location?: string;
  soilType?: string;
  cultivationStatus: FieldCultivationStatus;
  photoFileId?: string;
  documentFileIds?: string[];
  notes?: string;
}

export interface FieldProfileInput {
  code?: string;
  name?: string;
  location?: string;
  soilType?: string;
  /** Id of an uploaded file, not a URL — resolve it with getFileDownloadUrl before rendering. */
  photoFileId?: string;
  /** Land documents (file ids) attached to the plot. */
  documentFileIds?: string[];
  notes?: string;
}

export async function createField(data: {
  farmerId: string;
  geometry: { coordinates: number[][][] };
  source: FieldGeometrySource;
  areaHa?: number;
} & FieldProfileInput): Promise<BackendField> {
  return api.post<BackendField>('/geo/fields', data);
}

export async function updateField(fieldId: string, data: FieldProfileInput & {
  cultivationStatus?: FieldCultivationStatus;
  photoFileId?: string;
}): Promise<BackendField> {
  return api.patch<BackendField>(`/geo/fields/${fieldId}`, data);
}

export async function deleteField(fieldId: string): Promise<void> {
  return api.delete(`/geo/fields/${fieldId}`);
}

export async function verifyField(fieldId: string): Promise<BackendField> {
  return api.post<BackendField>(`/geo/fields/${fieldId}/verify`);
}

export async function listFieldsByFarmer(farmerId: string): Promise<BackendField[]> {
  return api.get<BackendField[]>(`/geo/farmers/${farmerId}/fields`);
}

export async function listOverlappingFields(): Promise<BackendField[]> {
  return api.get<BackendField[]>('/geo/fields/overlapping');
}
